import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-terms',
  templateUrl: './hosting-terms.component.html',
  styleUrls: ['./hosting-terms.component.css'],
  standalone: false
})
export class HostingTermsComponent {}
